import { DataSourceCategoryEntity } from '@nk/data-entities-lib';

export type DataSourceCategoryDict = { [key: string]: boolean };

export function getDataSourceKey(orgNrSchema: string): string | null {
  switch (orgNrSchema) {
    case 'NO':
      return 'ownership_norway';
    case 'DK':
      return 'cvr^^^ownership_denmark^^^elasticsearch';
    case 'SE':
      return 'se_proff^^^ownership_sweden^^^api';
    default:
      return null;
  }
}

export function getDataSourceCategoryList(dataSourceCategoriesDict: DataSourceCategoryDict): string[] {
  return dataSourceCategoriesDict
    ? Object.keys(dataSourceCategoriesDict).filter((key) => {
        return dataSourceCategoriesDict[key] === true;
      })
    : [];
}

export const DATA_SOURCE_CATEGORY_KEY_PRIORITY: { [key: string]: string } = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'event^^^announcement': '1',
  'event^^^court': '2',
  'event^^^news': '3',
  'event^^^collateral': '4',
  'event^^^company_event_risk_score': '5',
  'event^^^public_communication': '6',
  'event^^^ownership_changes': '7',
  /* eslint-enable @typescript-eslint/naming-convention */
};

export const EXCLUDED_DATA_SOURCE_CATEGORY_KEYS: string[] = ['event^^^procurements'];

export function sortAndFilterDataSourceCategories(
  dataSourceCategories: DataSourceCategoryEntity[],
): DataSourceCategoryEntity[] {
  const fallbackPriority = '99';
  return dataSourceCategories
    .filter((dsc) => !EXCLUDED_DATA_SOURCE_CATEGORY_KEYS.includes(dsc.data_source_category_key))
    .sort((a, b) => {
      const aPriority = DATA_SOURCE_CATEGORY_KEY_PRIORITY[a.data_source_category_key] ?? fallbackPriority;
      const bPriority = DATA_SOURCE_CATEGORY_KEY_PRIORITY[b.data_source_category_key] ?? fallbackPriority;
      return aPriority.localeCompare(bPriority);
    });
}
